import { Box, Flex } from '@rebass/grid';
import React, { FC } from 'react';
import styled from 'styled-components';
import createImgProps from '../utils/createImgProps';
import Divider from './Divider';
import ReviewStats from './ReviewStats';
import SummaryBar from './SummaryBar';
import Review from './Review';
import { ReviewData } from '../utils/normalizeReviewData';

const ReadReview: FC<React.PropsWithChildren<{ data: ReviewData }>> = ({ data }) => {
    const { review, ownerName, jpeg, webp, reviewStats } = data;

    if (!review) {
        return null;
    }

    return (
        <Flex flexDirection={['column-reverse', null, null, 'row']} justifyContent="space-between" width={1}>
            <Box flex={1} mr={[null, null, 5, 8]}>
                <Box>
                    <ReviewStats variant="light" reviewStats={reviewStats} rentalUnitType={data.rentalUnit?.type} />
                    <StyledReview
                        hideRating
                        review={review}
                        ownerName={ownerName}
                        ownerImage={jpeg && webp && { ...createImgProps(jpeg, webp), loading: 'lazy' }}
                    />
                </Box>
            </Box>

            <Box mb={6} ml={[3, null, 4]}>
                <SummaryBar data={data.item} showOnMobile hidePrices />
                <Divider className="lt-m" m={0} mt={5} />
            </Box>
        </Flex>
    );
};

export default ReadReview;

const StyledReview = styled(Review)`
    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.m}) {
        margin-top: ${({ theme }) => theme.spacing['50_Semi']};
    }
`;
